export default __webpack_public_path__ + "static/img-cobia-500x325-9cefb1e5b6c910d1f36e1895927fa59a.png";